import React from 'react';
import styled from 'styled-components';
import Item, { Section, Content, Button } from './item';
import { offsets, fontSizes, colors } from '../../../styles';

const Price = styled(Section)`
  font-size: ${fontSizes.sm};
  color: ${colors.black};
`;

const WokItem = ({ id, name, weight, price, pictureId }) => (
  <Item
    id={id}
    imgUrl={require(`../../../images/menu-pics/${pictureId}.png`)}
    imgAlt={`wok-${id}`}
    name={name}
  >
    {weight && (
      <Section>
        <b>Вес</b>: {weight} гр
      </Section>
    )}
    <Price>
      <b>Цена</b>: {price} р
    </Price>
  </Item>
);

export default WokItem;
